import { render, staticRenderFns } from "./HeaderValues.vue?vue&type=template&id=bbbfcfa6&scoped=true"
import script from "./HeaderValues.vue?vue&type=script&lang=js"
export * from "./HeaderValues.vue?vue&type=script&lang=js"
import style0 from "./HeaderValues.vue?vue&type=style&index=0&id=bbbfcfa6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbfcfa6",
  null
  
)

export default component.exports